import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { IconComponent } from './icon.component';
import { PriceComponent } from './price.component';
import { TranslatePipe } from '../pipes/translate.pipe';

/** Sticky "view cart" bar shown above the tab bar when the cart has items. */
@Component({
  selector: 'app-cart-bar',
  standalone: true,
  imports: [NgIf, IconComponent, PriceComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div *ngIf="count > 0"
      style="position:absolute;inset-inline:0;bottom:10px;padding:0 14px;z-index:40;pointer-events:none">
      <button (click)="open.emit()"
        style="width:100%;pointer-events:auto;height:56px;border-radius:15px;border:none;cursor:pointer;background:var(--brand);
               color:#fff;display:flex;align-items:center;justify-content:space-between;padding:0 8px 0 18px;
               box-shadow:0 12px 28px -10px var(--brand-shadow), 0 2px 8px rgba(0,0,0,0.12);font-family:var(--fr-font)">
        <span style="display:flex;align-items:center;gap:11px">
          <span class="fr-num" style="background:rgba(255,255,255,0.22);min-width:26px;height:26px;border-radius:8px;
                display:flex;align-items:center;justify-content:center;font-weight:750;font-size:14px">{{ count }}</span>
          <span style="font-weight:700;font-size:15.5px">{{ label | t }}</span>
        </span>
        <span style="display:flex;align-items:center;gap:10px">
          <app-price [value]="total" [size]="16" [weight]="750" color="#fff"></app-price>
          <span style="width:40px;height:40px;border-radius:11px;background:rgba(255,255,255,0.18);display:flex;align-items:center;justify-content:center">
            <app-icon name="solar:alt-arrow-right-linear" [size]="20"></app-icon>
          </span>
        </span>
      </button>
    </div>`,
})
export class CartBarComponent {
  @Input() count = 0;
  @Input() total = 0;
  @Input() label = 'View cart';
  @Output() open = new EventEmitter<void>();
}
